// @core/api/endpoints/audittrail/export_audit_trail.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExportAuditTrailRequest,
  ExportAuditTrailResponse,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Export audit trail
 * Exports the audit trail in a legally admissible format with digital signatures and chain verification proof. Supports filtering by date range, resource, and actor.
 */
export async function ExportAuditTrail(
  data: ExportAuditTrailRequest,
  options?: RequestOptions
): Promise<ExportAuditTrailResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/export`;
  const requestOptions = options;
  return client.post<ExportAuditTrailResponse>(requestPath, data, requestOptions);
}
